import React from "react";
import { Card, Button, Typography, Space, Alert } from "antd";

const { Title, Paragraph, Text } = Typography;

export default function Snapshots() {
  return (
    <Space
      direction="vertical"
      size="large"
      style={{ width: "100%" }}
    >
      {/* INFO CARD */}
      <Card>
        <Title level={5}>SNAPSHOTS</Title>

        <Paragraph>
          Snapshots are instant copies of your server’s disks.
        </Paragraph>

        <Paragraph>
          You can create a new server from a snapshot and even
          transfer them to a different project.
        </Paragraph>

        <Paragraph>
          We recommend that you power off your server before
          taking a snapshot to ensure data consistency.
        </Paragraph>

        <Paragraph>
          <Text strong>
            Snapshots cost $0.013/GB/month (incl. 0% VAT).
          </Text>
        </Paragraph>

        <Paragraph type="secondary">
          You currently don’t have any snapshots for this server.
        </Paragraph>

        <Button danger type="primary">
          Take snapshot
        </Button>
      </Card>

      {/* EMPTY STATE (OPTIONAL) */}
      <Alert
        message="No snapshots available"
        description="Create your first snapshot to protect your server state."
        type="info"
        showIcon
      />
    </Space>
  );
}
